import {
  Button,
  CardContent,
  Grid,
  TextField
} from '@material-ui/core';
import html2canvas from 'html2canvas';
import { toast } from 'react-toastify';
import { Search, Pageview } from '@material-ui/icons';
import Brightness1Icon from '@material-ui/icons/Brightness1';
import { localizationTable, options } from 'constants/table';
import { useParams } from 'react-router-dom';
import { EnrollmentData, LessonContentData } from 'services/dataService';
import { format, parseISO } from 'date-fns';
import FileSaver from 'file-saver';
import MaterialTable, { MTableToolbar } from 'material-table';
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo
} from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CertificateData, ModuleData } from 'services/dataService';
import HandleBlockEnrollment from './components/HandleBlockEnrollment';
import HandleNewExam from './components/HandleNewExam';
import { useStyles } from './styles';
import HandleFinishedExam from './components/HandleFinishedExam';
import HandleFinishedCourse from './components/HandleFinishedCourse';

export default forwardRef((_, ref) => {
  const classes = useStyles();
  const tableRef = useRef();
  const [modalStatus, setModalStatus] = useState(false);
  const [modalExam, setModalExam] = useState(false);
  const [modules, setModules] = useState([]);
  const [arrayLesson, setArrayLesson] = useState([]);
  const [modalFinishedExam, setModalFinishedExam] = useState(false);
  const [modalFinishedCourse, setModalFinishedCourse] = useState(false);
  const [enrollment, setEnrollment] = useState(null);
  const [data, setData] = useState();
  
  const [filter, setFilter] = useState({
    name: '',
    status: 2,
  });
  const { id } = useParams();
  const { register, handleSubmit, control } = useForm();
  const { t } = useTranslation([
    'label',
    'toastify',
    'tables',
    'form',
    'button',
    'validation',
    'message',
  ]);

  const filterTable = useCallback((filter) => {
    getData(filter);
  });

  const getData = async (filter) => {
    const enrollment = await EnrollmentData.getEnrollment(id, filter);
    
    const newEnrollment = enrollment.data.enrollments
      .map((elem) => ({
        id_enrollment: elem?.id_enrollment,
        id_course: elem.id,
        id_user: elem.id_user,
        id_company: elem.id_company,
        id_company_course: elem.id_company_course,
        date: elem.createdAt,
        name: elem.company_course.course.name,
        teacher: elem.company_course.course?.course_author?.User?.name,
        progress: elem.company_course.course?.percent_progress,
        status: elem.company_course.status,
        active: elem.active,
        finished_at: elem.finished_at,
        score_course: elem.company_course.course?.score,
        score_exam: elem.company_course.course?.score_exam,
        online_classroom: elem.company_course.online_classroom
      }))
      .filter((elem) => elem.online_classroom);

    setData(newEnrollment);
  };

  const handleModalOpen = useCallback((enrollment) => {
    setModalStatus(true);
    setEnrollment(enrollment);
  }, []);

  const handleModalFinished = useCallback((enrollment) => {
    setModalFinishedCourse(true);
    setEnrollment(enrollment);
  }, []);

  const handleModalExam = useCallback((enrollment) => {
    setModalExam(true);
    setEnrollment(enrollment);
  }, []);

  const handleDownloadCertificate = useCallback(async (rowData) => {
    try {
      toast.success(t('toastify:commons.toast_success_certificate'));
      const response = await ModuleData.getModuleByIdCourse(rowData?.id_course);
      const arrayModule = response.data.modules
        .sort((a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0))
        .map((module, index) => {
          return {
            index,
            id: module?.id || null,
            title: module.title,
          };
        });

      const arrayLes = response.data.modules.map((module) => {
        return module.lessons.map((lesson) => {
          return {
            id_lesson: lesson.id,
            id_course: lesson.id_course,
            id_module: lesson.id_module,
            title: lesson.title,
          };
        });
      });

      setModules(arrayModule);
      setArrayLesson(arrayLes.flat());

      const secondPageCanvas = await html2canvas(document.getElementById('certificate-second-page'), {
        scale: 2,
        useCORS: true,
      });
      const secondPageImage = secondPageCanvas.toDataURL('image/png');

      const requestBody = {
        id_enrollment: rowData?.id_enrollment,
        id_user: rowData?.id_user,
        certificate_create_date: rowData?.finished_at,
        secondPageImage,
      };

      const { data: base64CertificateFile } = await CertificateData.download(
        rowData?.id_company_course,
        requestBody
      );

      const responsePDF = await fetch(base64CertificateFile);
      const blob = await responsePDF.blob();
      FileSaver.saveAs(blob, `${rowData?.name}.pdf`);      

    } catch (error) {
      console.error('Erro ao gerar o certificado:', error);
    }
  }, []);

  const columns = useMemo(() => {
    const maxHeight = 520; 
    const estModuleTitle = 24;
    const estLesson = 16;
  
    const colLimit = 3;
    const colList = Array.from({ length: colLimit }, () => []);
    let currentHeight = 0;
    let colIndex = 0;

    let totalLessonsCount = 0;
    const maxTotalLessons = 50; 
  
    for (const module of modules) {
      if (totalLessonsCount >= maxTotalLessons) break;
  
      const lessons = arrayLesson
        .filter(lesson => lesson.id_module === module.id)
        .slice(0, maxTotalLessons - totalLessonsCount);
  
      if (lessons.length === 0) continue;
  
      const estHeight = estModuleTitle + lessons.length * estLesson;
  
      if (currentHeight + estHeight > maxHeight && colIndex < colLimit - 1) {
        colIndex++;
        currentHeight = 0;
      }
  
      colList[colIndex].push({ ...module, lessons });
      currentHeight += estHeight;
      totalLessonsCount += lessons.length;
    }
  
    return colList;
  }, [modules, arrayLesson]);
  

  const finishCourse = useCallback(async () => {
    if (enrollment) {
      const { id_user, id_company_course } = enrollment;
      await LessonContentData.releaseFinishedCourse(
        id_user,
        id_company_course,
      );
      setModalFinishedExam(true);
      setEnrollment(enrollment);
    }
  }, [filterTable, enrollment]);

  const lockOrUnlockCourseEnrollment = useCallback(async () => {
    if (enrollment) {
      const { id_company, id_user, id_company_course, active } = enrollment;
      if (active) {
        await EnrollmentData.lockEnrollment(
          id_user,
          id_company,
          id_company_course
        );
      } else {
        await EnrollmentData.unlockEnrollment(
          id_user,
          id_company,
          id_company_course
        );
      }

      setEnrollment(null);
      filterTable();
    }
  }, [filterTable, enrollment]);

  useEffect(() => {
    getData();
  }, []);

  useImperativeHandle(ref, () => ({
    updateTable() {
      getData();
    },
  }));

  const getStatus = useCallback(
    (value) => {
      if (value)
        return (
          <div className={classes.status}>
            <Brightness1Icon
              fontSize="small"
              color="primary"
              style={{ marginRight: 5 }}
            />
            {t('label:commons.label_status_active')}
          </div>
        );
      else
        return (
          <div className={classes.status}>
            <Brightness1Icon
              color="secondary"
              fontSize="small"
              style={{ marginRight: 5 }}
            />
            {t('label:commons.label_status_inactive')}
          </div>
        );
    },
    [t]
  );

  return (
    <div>
      <div
        id="certificate-second-page"
        style={{
          position: 'absolute',
          top: '-9999px',
          left: '-9999px',
          width: '1366px',
          height: '768px',
          padding: '25px',
          boxSizing: 'border-box',
          background: '#fff',
          fontFamily: 'Arial, sans-serif',
          fontSize: '16px',
          color: '#000',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <h2 style={{ textAlign: 'center', fontWeight: 'bold', marginBottom: '20px', marginLeft: '20px' }}>
            Conteúdo Programático
          </h2>

          <div style={{ display: 'flex', gap: '40px' }}>
            {columns.map((col, idx) => (
              <div key={idx} style={{ flex: 1 }}>
                {col.map((module, i) => (
                  <div key={i} style={{ marginBottom: '20px', breakInside: 'avoid' }}>
                    <strong style={{ display: 'block', marginBottom: '4px' }}>
                      {module.title}
                    </strong>
                    {module.lessons.map((lesson, j) => (
                      <div key={j} style={{ fontSize: '14px', lineHeight: '1.6', marginLeft: '10px' }}>
                        Aula {lesson.order?.toString().padStart(2, '0')} – {lesson.title}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
        </div>
      </div>
      <MaterialTable
        title={`${t('tables:course.title')}`}
        tableRef={tableRef}
        columns={[
          { title: `${t('tables:commons.name_column')}`, field: 'name' },
          {
            title: `${t('tables:course.createdAt_column_register')}`,
            field: 'date',
            render: (rowData) => format(parseISO(rowData.date), 'dd/MM/yyyy'),
          },
          {
            title: `${t('tables:commons.status_column')}`,
            field: 'status',
            render: (rowData) => getStatus(rowData.status),
          },
          {
            title: `${t('tables:Tabs.progress_settings')}`,
            field: 'progress',
            render: (rowData) =>
              `${((rowData.progress * 100) / 100).toFixed(2)}%`,
          },

          {
            title: `${t('tables:course.teacher_column')}`,
            field: 'teacher',
          },
        ]}
        data={data}
        actions={[
          (rowTable) => {
            const isDisabled = rowTable?.progress < 100 || !rowTable?.active || rowTable.score_exam < rowTable.score_course;
            const shouldDisableDownloadButton = rowTable?.online_classroom === true ? isDisabled : false;

            return {
              icon: 'download',
              tooltip: `${t('button:Course.btn_download_certificate')}`,
              onClick: (_, rowData) => handleDownloadCertificate(rowData),
              iconProps: {
                color: shouldDisableDownloadButton ? 'disabled' : 'primary',
              },
              disabled: shouldDisableDownloadButton,
            };
          },
          (rowTable) => ({
            icon: 'sync',
            tooltip: `${t('button:Course.btn_new_exam')}`,
            onClick: (_, rowData) => handleModalExam(rowData),
            iconProps: {
              color:
                rowTable?.progress < 100 || !rowTable?.active
                  ? 'disabled'
                  : 'primary',
            },
            disabled: rowTable?.progress < 100 || !rowTable?.active,
          }),
          (rowTable) => ({
            icon: rowTable?.active ? 'lock' : 'lock_open',
            tooltip: rowTable?.active
              ? `${t('button:Course.btn_lock_course')}`
              : `${t('button:Course.btn_unlock_course')}`,
            onClick: (_, rowData) => handleModalOpen(rowData),
            iconProps: {
              style: { color: !rowTable?.active ? '#2DCE98' : '#F53C56' },
            },
          }),

          (rowTable) => ({
            icon: 'list_alt',
            tooltip: `${t('button:Course.btn_force_compeletion')}`,
            onClick: (event, rowData) => handleModalFinished(rowData),
            iconProps: {
              color:
                rowTable?.progress < 100
                  ? 'primary'
                  : 'disabled',
            },
            disabled: rowTable?.progress === 100
          }),
          (rowTable) => {
            const isDisabled = rowTable?.progress < 100 || !rowTable?.active || rowTable.score_exam < rowTable.score_course;
            const shouldDisableCheckButton = rowTable?.online_classroom === true ? isDisabled : false;
            return {
              icon: ()=> <Pageview style={{ color: shouldDisableCheckButton ?  '#BDC2D2' :  '#176AE6'}}/>,
              tooltip: `${t('button:Course.btn_validate_certificate')}`,
              onClick: (event, rowData) => {
                window.open(`/validate/${rowData.id_company_course}/${rowData.id_enrollment}/certificate`,'_blank');
              },       
              iconProps: {
                color: shouldDisableCheckButton ? 'disabled' : 'primary',
              },
              disabled: shouldDisableCheckButton,
            };
          },
        ]}
        components={{
          search: false,
          title: true,
          Toolbar: (props) => (
            <div>
              <MTableToolbar {...props} />
              <CardContent>
                <form onSubmit={handleSubmit(filterTable)}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        defaultValue={''}
                        variant="outlined"
                        name="name"
                        inputRef={register({ required: false })}
                        label={t('tables:user_solicitations.name_column')}
                      />
                    </Grid>
                    {/* <Grid item xs={12} md={2}>
                      <FormControl fullWidth>
                        <InputLabel shrink htmlFor="form-select">
                          {t('form:commons.input_status')}
                        </InputLabel>

                        <Controller
                          as={
                            <Select
                              inputProps={{
                                id: 'form-select',
                              }}
                              fullWidth
                              label="Status"
                              value={filter.status}
                              onChange={(e, value) => {
                                setFilter({
                                  ...filter,
                                  status: value.props.value,
                                });
                              }}
                            >
                              <MenuItem value={2}>
                                {t('label:commons.label_status_active')}
                              </MenuItem>
                              <MenuItem value={3}>
                                {t('label:commons.label_status_inactive')}
                              </MenuItem>
                            </Select>
                          }
                          name="status"
                          defaultValue={2}
                          control={control}
                        />
                      </FormControl>
                    </Grid> */}
                    <Grid item xs={12} md={1} />
                    <Grid item xs={12} md={5} className={classes.actions}>
                      <Button
                        color="primary"
                        variant="contained"
                        size="large"
                        type="submit"
                      >
                        <Search style={{ marginRight: '5px' }} />
                        {t('button:commons.btn_advanced_filter')}
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </div>
          ),
        }}
        localization={localizationTable(t)}
        options={options}
      />

      <HandleBlockEnrollment
        closeModal={setModalStatus}
        isOpen={modalStatus}
        onConfirm={lockOrUnlockCourseEnrollment}
        customMessage={t(
          `message:courses.${enrollment && enrollment.active ? 'lock' : 'unlock'
          }`
        )}
      />

      <HandleNewExam
        closeModal={setModalExam}
        isOpen={modalExam}
        onConfirm={lockOrUnlockCourseEnrollment}
        enrollment={enrollment}
      />

      <HandleFinishedExam
        closeModal={setModalFinishedExam}
        isOpen={modalFinishedExam}
        onConfirm={lockOrUnlockCourseEnrollment}
        enrollment={enrollment}
      />

      <HandleFinishedCourse
        closeModal={setModalFinishedCourse}
        isOpen={modalFinishedCourse}
        onConfirm={finishCourse}
        customMessage={t('message:courses.finishCourse')}
      />
    </div>
  );
});
